import type { Translations } from "../types";

const ja: Translations = {
  "meta.title": "国別クリックマップ",
  "meta.description":
    "インタラクティブな世界地図：国ごとの無料クリックに加え、Stripe、PayPal、Buy Me a Coffee による有料サポートも可能です。",

  "app.title": "国別クリックマップ",

  "map.intro":
    "地図上の国をクリックすると無料で1票を投じられます。資金的なサポートを送ることもでき、どちらも下の総合ランキングに反映されます。この地図はあくまで本アプリ内でのサポート状況を示すものであり、実際の国家の富や GDP を表すものではありません。",
  "map.verifying": "確認中……",
  "map.confirmNotRobot": "無料クリックを追加する前に、ロボットではないことを簡単に確認してください：",
  "map.tryAgain": "再試行",
  "map.registeringClick": "クリックを登録中……",
  "map.selectedCountry": "選択中の国：{name}",
  "map.selectFirstFeedback": "国が選択されました。無料クリックを追加するには、まず下でロボットではないことを確認してください。",
  "map.verificationExpired": "確認の有効期限が切れました——もう一度ロボットではないことを確認してください。",
  "map.slowDown": "少しゆっくり——次のクリックまで少し待ってください。",
  "map.clickFailed": "クリックを登録できませんでした。もう一度お試しください。",
  "map.clickErrorGeneric": "クリックの登録中にエラーが発生しました。",
  "map.leaderboardHeading": "国別ランキング",
  "map.emptySelection": "地図上で国を選択してクリックまたはサポートしてください。",
  "map.loadingData": "データを読み込み中……",

  "worldmap.loadError": "地図を読み込めませんでした。",
  "worldmap.resetZoom": "ズームをリセット",
  "worldmap.resetButton": "⤾ リセット",
  "worldmap.loadingMap": "地図を読み込み中……",
  "worldmap.unknownCountry": "不明",
  "worldmap.ariaClicks": "{name}：{clicks} クリック",
  "worldmap.tooltipClicks": "{clicks} クリック",

  "legend.fewer": "クリック数 少",
  "legend.more": "クリック数 多",

  "list.empty": "まだクリックがありません。最初の1人になりましょう！",
  "list.ariaLabel": "クリック数による国別ランキング",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY が設定されていません——設定方法は README を参照してください。",
  "human.verificationFailedGeneric": "確認に失敗しました。",
  "human.networkError":
    "確認サーバーに接続できませんでした（ネットワークエラー）——VITE_SUPABASE_URL、verify-human がデプロイされているか、ALLOWED_ORIGIN を確認してください。詳細は README/NAVODILA をご覧ください。",
  "human.verificationFailedRetry": "確認に失敗しました。もう一度お試しください。",

  "provider.stripe": "💳 カード（Stripe）",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "選択中の国",
  "panel.currentlyRanked": "現在の順位 #{rank}",
  "panel.shareCopied": "コピーしました ✓",
  "panel.shareShared": "共有しました ✓",
  "panel.shareButton": "🔗 共有",

  "panel.tableClicks": "クリック数",
  "panel.tableFree": "無料",
  "panel.tablePaid": "有料",
  "panel.rowAllTime": "累計",
  "panel.rowThisYear": "今年",
  "panel.rowThisWeek": "今週",
  "panel.rowToday": "今日",

  "panel.totalCombined": "合計：",
  "panel.totalSupport": "サポート合計：",

  "panel.paymentMethod": "支払い方法",
  "panel.noPaymentMethod": "現在利用できる支払い方法がありません。",
  "panel.supportAmount": "サポート金額（EUR）",
  "panel.amountRange": "金額は {min} 〜 {max} の範囲で指定してください。",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "推定有料クリック数：",
  "panel.ratioInfo":
    "レート：{a} = {b} クリック（例：{c} = {d} クリック）。これは支払い前の概算にすぎません——最終的なクリック数は、実際に確認された支払いに基づき、常にサーバー側で計算・確定されます。",
  "panel.preparing": "準備中……",
  "panel.continueWith": "{provider} で続ける",
  "panel.choosePaymentMethod": "支払い方法を選択",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME が設定されていません——設定方法は README を参照してください。",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID が設定されていません——設定方法は README を参照してください。",

  "panel.paypalAmountInfo": "金額：{amount}（推定 {clicks} クリック）。下の PayPal ボタンから支払いを完了してください。",
  "panel.back": "← 戻る",

  "panel.bmcWarningTitle": "⚠️ BuyMeCoffee に進む前に：",
  "panel.bmcWarningBody":
    "決済時のメッセージ／メモ欄に下記のコードを貼り付けてください——これが、どの国へのサポートかを判別する唯一の方法です。コードがないと、支払いをどの国にも割り当てることができません。",
  "panel.copy": "コピー",
  "panel.copied": "コピーしました ✓",
  "panel.suggestedAmount": "推奨金額：",
  "panel.bmcAmountNote":
    "（推定 {clicks} クリック）。残念ながら BuyMeCoffee はリンク経由で金額を引き継ぐことに対応していないため、サイト上でご自身で金額を入力・選択してください。実際のクリック数は、この概算ではなく BuyMeCoffee で実際に送金された金額に基づいて計算されます。",
  "panel.openBmc": "BuyMeCoffee を開いて続ける →",
  "panel.waitingProvider": "決済プロバイダーからの支払い確認を待っています……",
  "panel.waitingConfirmation": "支払いの確認を待っています……",
  "panel.timedOut":
    "確認がタイムアウトしました。支払いを完了している場合、サーバーが確認を受け取り次第地図が更新されます——時間が少しかかることがあります。",
  "panel.checkAgain": "再確認",

  "panel.cancelled": "支払いがキャンセルされたか、完了しませんでした。地図に変更はありません。",
  "panel.tryAgain": "再試行",

  "panel.confirmed": "✅ サポートが確認されました！",
  "panel.confirmedBody": "{country} は {amount} で {clicks} 件の有料クリックを獲得しました。",

  "panel.errorPreparingSupport": "サポートの準備中にエラーが発生しました。",
  "panel.errorPreparingPayment": "支払いの準備中にエラーが発生しました。",
  "panel.errorConfirmingPayment": "支払いの確認中にエラーが発生しました。",
  "panel.errorPayingPaypal": "PayPal での支払い中にエラーが発生しました。",

  "share.unranked": "{flag}{country} が世界地図であなたのサポートを必要としています！\nランキングを押し上げる手助けをしましょう 👇",
  "share.rank1": "{flag}{country} は現在1位です！\n一緒にトップを守りましょう 👇",
  "share.rankN": "{flag}{country} は現在 #{rank} 位です！\n一緒に1位を目指しましょう 👇",

  "language.switcherLabel": "言語",
};

export default ja;
